/**
 * Maps sidebar path (or path prefix) to backend permission module key.
 * Aligned with new sidebar groups and modules.
 */
export const PATH_TO_MODULE_KEY: Record<string, string> = {
  '/dashboard': 'dashboard',
  '/approvals': 'approvals',
  '/approvals/templates': 'approval_templates',
  '/documents': 'documents',
  '/documents/new': 'documents',
  '/documents/business-rules': 'documents',
  '/e-forms': 'e_form_submissions',
  '/e-forms/submissions': 'e_form_submissions',
  '/e-forms/builder': 'e_form_definitions',
  '/e-forms/report-builder': 'e_form_submissions',
  '/operations/noon-reports': 'noon_reports',
  '/examples/items': 'examples',
  '/emails': 'emails',
  '/chat': 'chat',
  '/email-accounts': 'email_accounts',
  '/email-signatures': 'email_signatures',
  '/search-folders': 'search_folders',
  '/admin/email-logs': 'email_logs',
  '/todos': 'todos',
  '/todos_monthly_view': 'todos',
  '/crm_tasks': 'crm_tasks',
  '/crm_tasks-monthly': 'crm_tasks',
  '/projects': 'projects',
  '/support-ticket': 'support_ticket',
  '/knowledge-base': 'knowledge_base',
  '/crm_notes': 'crm_notes',
  '/cardboard-crm-notes': 'crm_notes',
  '/client-vault': 'client_vault',
  '/vault-templates': 'vault_templates',
  '/clients': 'clients',
  '/leads': 'leads',
  '/offers': 'offers',
  '/catalog-items': 'catalog_items',
  '/offer-templates': 'offer_templates',
  '/settings/offer-pdf-layouts': 'offer_templates',
  '/calls': 'calls',
  '/appointments': 'appointments',
  '/appointments_calendar_view': 'appointments',
  '/marketing': 'marketing',
  '/client-invoices': 'client_invoices',
  '/invoice-payments': 'invoice_payments',
  '/supplier-invoices': 'supplier_invoices',
  '/entities': 'suppliers',
  '/suppliers': 'suppliers',
  '/crew': 'crew',
  '/crew/list': 'crew',
  '/crew/list/print/:key': 'crew',
  '/crew/list/imo-print': 'crew',
  '/crew/officer-matrix': 'crew',
  '/crew/rightship-matrix': 'crew',
  '/crew/changes-per-vessel': 'crew',
  '/crew/certs-expiring': 'crew',
  '/crew/certificate-requirements': 'crew',
  '/crew/certificate-requirements/print': 'crew',
  '/crew/certificate-requirements/print/by-nationality': 'crew',
  '/crew/rank-requirements': 'crew',
  '/crew/rank-requirements/print': 'crew',
  '/crew/rank-requirements/print/by-nationality': 'crew',
  '/crew/reports': 'crew',
  '/crew/reports/operations': 'crew',
  '/crew/reports/operations/onboard/print': 'crew',
  '/crew/reports/operations/available/print': 'crew',
  '/crew/reports/operations/not-recommended/print': 'crew',
  '/crew/reports/compliance': 'crew',
  '/crew/reports/compliance/:focus/print': 'crew',
  '/crew/statistics': 'crew',
  '/crew/statistics/onboard': 'crew',
  '/crew/statistics/onboard/print': 'crew',
  '/crew/statistics/available': 'crew',
  '/crew/statistics/available/print': 'crew',
  '/crew/statistics/not-recommended': 'crew',
  '/crew/statistics/not-recommended/print': 'crew',
  '/crew/statistics/nationalities': 'crew',
  '/crew/statistics/compliance': 'crew',
  '/crew/statistics/people-payroll': 'crew',
  '/crew/statistics/mix': 'crew',
  '/crew/statistics/age': 'crew',
  '/crew/statistics/sign-on': 'crew',
  '/crew/statistics/sign-off': 'crew',
  '/crew/statistics/appraisal-grade': 'crew',
  '/crew/cert-gaps': 'crew',
  '/crew/cert-gaps/print': 'crew',
  '/crew/relief-board': 'crew',
  '/crew/relief-board/print': 'crew',
  '/crew/coe-watchlist': 'crew',
  '/crew/coe-watchlist/print': 'crew',
  '/crew/appraisal-nr': 'crew',
  '/crew/wage-allottee': 'crew',
  '/crew/previous-service': 'crew',
  '/crew/onboard-status': 'crew',
  '/crew/onboard-status/print': 'crew',
  '/crew/replacement-planner': 'crew',
  '/crew/replacement-planner/print': 'crew',
  '/crew/crew-changes-cost': 'crew',
  '/crew/crew-changes-cost/print': 'crew',
  '/crew/crew-changes-cost/new': 'crew',
  '/crew/crew-changes-cost/:id': 'crew',
  '/crew/crew-changes-cost/:id/edit': 'crew',
  '/mga': 'mga',
  '/wrh': 'wrh',
  '/wrh/compliance': 'wrh',
  '/wrh/reports': 'wrh',
  '/wrh/rules': 'wrh',
  '/wrh/arrangements': 'wrh',
  '/wrh/arrangements/report': 'wrh',
  '/wrh/sheet': 'wrh',
  '/wrh/sheet/rest-record': 'wrh',
  '/wrh/operation-types': 'wrh',
  '/vessel-operations': 'wrh',
  '/parameters/crew': 'crew_parameters',
  '/parameters/general': 'vessels',
  '/parameters/purchasing': 'store_items',
  '/parameters/supplies-catalog': 'store_items',
  '/parameters/spares-catalog': 'spare_items',
  '/parameters/pms': 'pms_record_statuses',
  '/parameters/finance': 'acc_companies',
  '/supplier-invoice-payments': 'supplier_payments',
  '/parameters/countries': 'countries',
  '/parameters/currencies': 'currencies',
  '/parameters/departments': 'departments',
  '/parameters/management-companies': 'management_companies',
  '/parameters/store-categories': 'store_categories',
  '/parameters/vessels': 'vessels',
  '/parameters/ports': 'ports',
  '/supplies/requisitions': 'supply_requisitions',
  '/vessel-modules/dashboard': 'vessel_dashboard',
  '/vessel-modules': 'vessel_supply_requisitions',
  '/supplies/supplier-enquiries': 'supplier_enquiries',
  '/supplies/excel-document-templates': 'supply_requisitions',
  '/system/reference-templates': 'supply_requisitions',
  '/system/mga-sheet-columns': 'mga',
  '/supplies/reference-templates': 'supply_requisitions',
  '/supplies/supplier-quotations': 'supplier_quotations',
  '/supplies/quotation-evaluations': 'quotation_evaluations',
  '/supplies/supply-purchase-orders': 'supply_purchase_orders',
  '/supplies/supply-forwarding-statuses': 'supply_forwarding_statuses',
  '/supplies/supply-forwardings': 'supply_forwardings',
  '/supplies/supply-deliveries': 'supply_deliveries',
  '/supplies/supply-invoices': 'supply_invoices',
  '/supplies/supply-cases': 'supply_cases',
  '/spares/requisitions': 'spare_requisitions',
  '/spares/supplier-enquiries': 'spare_supplier_enquiries',
  '/spares/supplier-quotations': 'spare_supplier_quotations',
  '/spares/quotation-evaluations': 'spare_quotation_evaluations',
  '/spares/spare-purchase-orders': 'spare_purchase_orders',
  '/spares/spare-forwarding-statuses': 'spare_forwarding_statuses',
  '/pms/pms-record-statuses': 'pms_record_statuses',
  '/pms/pms-criticalities': 'pms_criticalities',
  '/pms/pms-equipment-statuses': 'pms_equipment_statuses',
  '/pms/pms-maintenance-strategies': 'pms_maintenance_strategies',
  '/pms/pms-job-types': 'pms_job_types',
  '/pms/pms-schedule-types': 'pms_schedule_types',
  '/pms/pms-interval-units': 'pms_interval_units',
  '/pms/pms-work-order-statuses': 'pms_work_order_statuses',
  '/pms/pms-work-order-sources': 'pms_work_order_sources',
  '/pms/pms-approval-statuses': 'pms_approval_statuses',
  '/pms/pms-step-statuses': 'pms_step_statuses',
  '/pms/pms-counter-types': 'pms_counter_types',
  '/pms/pms-counter-sources': 'pms_counter_sources',
  '/pms/pms-measurement-results': 'pms_measurement_results',
  '/pms/pms-defect-severities': 'pms_defect_severities',
  '/pms/pms-defect-statuses': 'pms_defect_statuses',
  '/pms/pms-equipment-instance-statuses': 'pms_equipment_instance_statuses',
  '/pms/pms-safety-requirement-types': 'pms_safety_requirement_types',
  '/pms/pms-document-types': 'pms_document_types',
  '/pms/pms-verification-statuses': 'pms_verification_statuses',
  '/pms/pms-department-types': 'pms_department_types',
  '/pms/pms-departments': 'pms_hierarchy',
  '/pms/hierarchy': 'pms_hierarchy',
  '/pms/due-jobs': 'pms_maintenance_jobs',
  '/pms/pms-equipment-systems': 'pms_hierarchy',
  '/pms/pms-components': 'pms_hierarchy',
  '/pms/pms-sub-components': 'pms_hierarchy',
  '/pms/pms-equipment': 'pms_hierarchy',
  '/pms/pms-equipment-instances': 'pms_hierarchy',
  '/pms/pms-maintenance-jobs': 'pms_maintenance_jobs',
  '/pms/pms-maintenance-counters': 'pms_maintenance_counters',
  '/pms/pms-work-orders': 'pms_work_orders',
  '/pms/pms-defects': 'pms_defects',
  '/pms/pms-tools': 'pms_tools',
  '/pms/pms-documents': 'pms_documents',
  '/spares/spare-forwardings': 'spare_forwardings',
  '/spares/spare-deliveries': 'spare_deliveries',
  '/spares/spare-invoices': 'spare_invoices',
  '/spares/spare-cases': 'spare_cases',
  '/spares/spare-libraries': 'spare_libraries',
  '/spares/spare-items': 'spare_items',
  '/spares/reference-templates': 'spare_reference_templates',
  '/port-calls': 'supply_cases',
  '/forwardings': 'supply_forwardings',
  '/supplies/port-calls': 'supply_cases',
  '/spares/port-calls': 'spare_cases',
  '/supplies/items': 'store_items',
  '/supplies/store-catalogs': 'store_catalogs',
  '/supplies/item-units': 'store_units',
  '/accounting': 'accounting',
  '/accounting/journals': 'acc_documents',
  '/accounting/payments/new': 'acc_documents',
  '/accounting/payments': 'acc_documents',
  '/accounting/journal-types': 'acc_document_types',
  '/accounting/account-types': 'acc_account_types',
  '/accounting/operational-types': 'acc_operational_types',
  '/accounting/companies': 'acc_companies',
  '/accounting/coa': 'acc_accounts',
  '/accounting/statement-lines': 'acc_accounts',
  '/accounting/periods': 'acc_periods',
  '/accounting/currency-rates': 'acc_currency_rates',
  '/accounting/reports': 'accounting',
  '/accounting/reports/analytical-ledgers': 'accounting',
  '/accounting/reports/journal-register': 'accounting',
  '/accounting/reports/journal': 'accounting',
  '/accounting/reports/general-ledger': 'accounting',
  '/accounting/reports/ledger-kartela': 'accounting',
  '/accounting/reports/link-statement': 'accounting',
  '/accounting/reports/trial-balance': 'accounting',
  '/accounting/reports/trial-balance-by-company': 'accounting',
  '/accounting/reports/open-items': 'accounting',
  '/accounting/reports/aging': 'accounting',
  '/accounting/reports/profit-and-loss': 'accounting',
  '/accounting/reports/balance-sheet': 'accounting',
  '/accounting/reports/intercompany': 'accounting',
  '/accounting/reports/running-cost-by-vessel': 'accounting',
  '/accounting/reports/department-analysis': 'accounting',
  '/accounting/reports/period-close-checklist': 'accounting',
  '/accounting/reports/audit-trail': 'accounting',
  '/payees': 'payees',
  '/payees-projection': 'payees_projection',
  '/recurring-payables': 'recurring_payables',
  '/expenses': 'expenses',
  '/expenses-summary': 'expenses',
  '/expense-categories': 'expense_categories',
  '/p_crm_expense_category': 'expense_categories',
  '/p_crm_expense_subcategory': 'expense_subcategories',
  '/packages': 'packages',
  '/support-agreements': 'support_agreements',
  '/client-services': 'client_services',
  '/client-services-yearly': 'client_services',
  '/service_renewal_reminders': 'client_services',
  '/task_type': 'task_type',
  '/task_category': 'task_category',
  '/task_status': 'task_status',
  '/priority': 'priority',
  '/ticket_status': 'ticket_status',
  '/call_type': 'call_type',
  '/service_type': 'service_type',
  '/frequency_type': 'frequency_type',
  '/duration': 'duration',
  '/p_crm_service_category': 'service_category',
  '/reminder_type': 'reminder_type',
  '/tax_authority': 'tax_authority',
  '/p_country': 'p_country',
  '/app_status': 'app_status',
  '/p_crm_invoice_category': 'invoice_category',
  '/p_crm_invoice_type': 'invoice_type',
  '/manufacturer': 'manufacturer',
  '/catalog-category': 'catalog_category',
  '/tags': 'tags',
  '/admin/users': 'users',
  '/admin/manning-agents': 'users',
  '/admin/database-browser': 'database_browser',
  '/admin/import-actions/impa-code': 'import_impa',
  '/admin/import-actions/accounts-plan': 'import_accounts_plan',
  '/admin/import-actions/companies': 'import_companies',
  '/admin/import-actions/journals': 'import_journals',
  '/presets-management': 'presets_management',
  '/settings': 'settings',
  '/admin/settings/application': 'settings',
  '/admin/ai-billing': 'ai_billing',
  '/admin/settings/files-storage': 'deleted_files',
  '/admin/settings/deleted-files': 'deleted_files',
  '/admin/settings/system-email-templates': 'settings',
  '/admin/settings/email-notifications': 'settings',
  '/configuration-settings': 'configuration_settings',
  '/activity-logs': 'activity_logs',
  '/notifications': 'notifications',
  '/workflows': 'workflows',
  '/custom-fields': 'custom_fields',
  '/tools/gemi-preview': 'import_gemi',
  '/tools/11888-preview': 'import_11888',
  '/tools/database-browser': 'database_browser', // legacy path
  '/import/invoice': 'import_invoice',
  '/reports/ReportGenerator': 'report_generator',
  '/reports/InvoicesByYear': 'reports',
  '/reports/InvoicesPaymentAnalysis': 'reports',
  '/reports/ExpensesByYear': 'reports',
  '/reports/Unpaid': 'reports',
  '/reports/AppointmentsReport': 'reports',
  '/reports/CallsReport': 'reports',
  '/reports/MissedCalls': 'reports',
  '/reports/MonthlyServices': 'reports',
  '/reports/ClientTasksMonthly': 'reports',
  '/reports/TodosMonthlyReport': 'reports',
};

export const LANDING_MODULE_ORDER = [
  'dashboard',
  'vessel_dashboard',
  'supply_cases',
  'supply_requisitions',
  'vessel_supply_requisitions',
  'vessel_pending_deliveries',
  'supplier_enquiries',
  'supplier_quotations',
  'quotation_evaluations',
  'supply_purchase_orders',
  'supply_forwardings',
  'supply_deliveries',
  'supply_invoices',
  'supply_forwarding_statuses',
  'spare_cases',
  'spare_requisitions',
  'spare_supplier_enquiries',
  'spare_supplier_quotations',
  'spare_quotation_evaluations',
  'spare_purchase_orders',
  'spare_forwardings',
  'spare_deliveries',
  'spare_invoices',
  'spare_forwarding_statuses',
  'pms_record_statuses',
  'pms_criticalities',
  'pms_equipment_statuses',
  'pms_maintenance_strategies',
  'pms_job_types',
  'pms_schedule_types',
  'pms_interval_units',
  'pms_work_order_statuses',
  'pms_work_order_sources',
  'pms_approval_statuses',
  'pms_step_statuses',
  'pms_counter_types',
  'pms_counter_sources',
  'pms_measurement_results',
  'pms_defect_severities',
  'pms_defect_statuses',
  'pms_equipment_instance_statuses',
  'pms_safety_requirement_types',
  'pms_document_types',
  'pms_verification_statuses',
  'pms_department_types',
  'pms_hierarchy',
  'pms_maintenance_jobs',
  'pms_maintenance_counters',
  'pms_work_orders',
  'pms_defects',
  'pms_tools',
  'pms_documents',
  'spare_libraries',
  'spare_categories',
  'spare_items',
  'spare_reference_templates',
  'store_items',
  'store_catalogs',
  'store_categories',
  'store_units',
  'vessels',
  'ports',
  'countries',
  'currencies',
  'departments',
  'management_companies',
  'crew_parameters',
  'suppliers',
  'crew',
  'mga',
  'wrh',
  'e_form_submissions',
  'e_form_definitions',
  'noon_reports',
  'users',
  'import_impa',
  'import_accounts_plan',
  'import_companies',
  'import_journals',
  'database_browser',
  'ai_billing',
] as const;

export type LandingModuleKey = (typeof LANDING_MODULE_ORDER)[number];

export const LANDING_MODULE_LABELS: Record<LandingModuleKey, string> = {
  dashboard: 'Dashboard',
  vessel_dashboard: 'Vessel dashboard',
  supply_cases: 'Supply cases',
  supply_requisitions: 'Supply requisitions',
  vessel_supply_requisitions: 'Vessel requisitions',
  vessel_pending_deliveries: 'Vessel pending deliveries',
  supplier_enquiries: 'RFQ',
  supplier_quotations: 'Quotations',
  quotation_evaluations: 'Evaluations',
  supply_purchase_orders: 'Purchase orders',
  supply_forwardings: 'Supply forwardings',
  supply_deliveries: 'Supply deliveries',
  supply_invoices: 'Supply invoices',
  supply_forwarding_statuses: 'Forwarding statuses',
  spare_cases: 'Spare cases',
  spare_requisitions: 'Spare requisitions',
  spare_supplier_enquiries: 'Spare RFQ',
  spare_supplier_quotations: 'Spare quotations',
  spare_quotation_evaluations: 'Spare evaluations',
  spare_purchase_orders: 'Spare purchase orders',
  spare_forwardings: 'Spare forwardings',
  spare_deliveries: 'Spare deliveries',
  spare_invoices: 'Spare invoices',
  spare_forwarding_statuses: 'Spare forwarding statuses',
  pms_record_statuses: "Record statuses",
  pms_criticalities: "Criticalities",
  pms_equipment_statuses: "Equipment statuses",
  pms_maintenance_strategies: "Maintenance strategies",
  pms_job_types: "Job types",
  pms_schedule_types: "Schedule types",
  pms_interval_units: "Interval units",
  pms_work_order_statuses: "Work order statuses",
  pms_work_order_sources: "Work order sources",
  pms_approval_statuses: "Approval statuses",
  pms_step_statuses: "Step statuses",
  pms_counter_types: "Counter types",
  pms_counter_sources: "Counter sources",
  pms_measurement_results: "Measurement results",
  pms_defect_severities: "Defect severities",
  pms_defect_statuses: "Defect statuses",
  pms_equipment_instance_statuses: "Equipment instance statuses",
  pms_safety_requirement_types: "Safety requirement types",
  pms_document_types: "Document types",
  pms_verification_statuses: "Verification statuses",
  pms_department_types: "Department types",
  pms_hierarchy: 'Equipment hierarchy',
  pms_maintenance_jobs: 'PMS maintenance jobs',
  pms_maintenance_counters: 'PMS counters',
  pms_work_orders: 'PMS work orders',
  pms_defects: 'PMS defects',
  pms_tools: 'PMS tools',
  pms_documents: 'PMS documents',
  spare_libraries: 'Spare libraries',
  spare_categories: 'Spare categories (folders)',
  spare_items: 'Spare items',
  spare_reference_templates: 'Spare reference templates',
  store_items: 'Store items',
  store_catalogs: 'Store catalogs',
  store_categories: 'Store categories',
  store_units: 'Store item units',
  vessels: 'Vessels',
  ports: 'Ports',
  countries: 'Countries',
  currencies: 'Currencies',
  departments: 'Departments',
  management_companies: 'Management companies',
  crew_parameters: 'Crew parameters',
  suppliers: 'Entities',
  crew: 'Crew Pool',
  mga: 'MGA',
  wrh: 'Working Rest Hours',
  e_form_submissions: 'E-Forms',
  e_form_definitions: 'E-Form builder',
  noon_reports: 'Noon reports',
  users: 'User management',
  import_impa: 'IMPA import',
  import_accounts_plan: 'Accounts plan import',
  import_companies: 'Companies import',
  import_journals: 'Journals import',
  database_browser: 'Database browser',
  ai_billing: 'AI billing',
};

const LANDING_MODULE_PATHS: Record<LandingModuleKey, string> = {
  dashboard: '/dashboard',
  vessel_dashboard: '/vessel-modules/:id/dashboard',
  supply_cases: '/supplies/supply-cases',
  supply_requisitions: '/supplies/requisitions',
  vessel_supply_requisitions: '/vessel-modules/:id/requisitions',
  vessel_pending_deliveries: '/vessel-modules/:id/pending-deliveries',
  supplier_enquiries: '/supplies/supplier-enquiries',
  supplier_quotations: '/supplies/supplier-quotations',
  quotation_evaluations: '/supplies/quotation-evaluations',
  supply_purchase_orders: '/supplies/supply-purchase-orders',
  supply_forwardings: '/supplies/supply-forwardings',
  supply_deliveries: '/supplies/supply-deliveries',
  supply_invoices: '/supplies/supply-invoices',
  supply_forwarding_statuses: '/parameters/purchasing?section=supplies-forwarding-statuses',
  spare_cases: '/spares/spare-cases',
  spare_requisitions: '/spares/requisitions',
  spare_supplier_enquiries: '/spares/supplier-enquiries',
  spare_supplier_quotations: '/spares/supplier-quotations',
  spare_quotation_evaluations: '/spares/quotation-evaluations',
  spare_purchase_orders: '/spares/spare-purchase-orders',
  spare_forwardings: '/spares/spare-forwardings',
  spare_deliveries: '/spares/spare-deliveries',
  spare_invoices: '/spares/spare-invoices',
  spare_forwarding_statuses: '/parameters/purchasing?section=spares-forwarding-statuses',
  pms_record_statuses: '/parameters/pms?section=record-statuses',
  pms_criticalities: '/parameters/pms?section=criticalities',
  pms_equipment_statuses: '/parameters/pms?section=equipment-statuses',
  pms_maintenance_strategies: '/parameters/pms?section=maintenance-strategies',
  pms_job_types: '/parameters/pms?section=job-types',
  pms_schedule_types: '/parameters/pms?section=schedule-types',
  pms_interval_units: '/parameters/pms?section=interval-units',
  pms_work_order_statuses: '/parameters/pms?section=work-order-statuses',
  pms_work_order_sources: '/parameters/pms?section=work-order-sources',
  pms_approval_statuses: '/parameters/pms?section=approval-statuses',
  pms_step_statuses: '/parameters/pms?section=step-statuses',
  pms_counter_types: '/parameters/pms?section=counter-types',
  pms_counter_sources: '/parameters/pms?section=counter-sources',
  pms_measurement_results: '/parameters/pms?section=measurement-results',
  pms_defect_severities: '/parameters/pms?section=defect-severities',
  pms_defect_statuses: '/parameters/pms?section=defect-statuses',
  pms_equipment_instance_statuses: '/parameters/pms?section=equipment-instance-statuses',
  pms_safety_requirement_types: '/parameters/pms?section=safety-requirement-types',
  pms_document_types: '/parameters/pms?section=document-types',
  pms_verification_statuses: '/parameters/pms?section=verification-statuses',
  pms_department_types: '/parameters/pms?section=department-types',
  pms_hierarchy: '/pms/hierarchy',
  pms_maintenance_jobs: '/pms/pms-maintenance-jobs',
  pms_maintenance_counters: '/pms/pms-maintenance-counters',
  pms_work_orders: '/pms/pms-work-orders',
  pms_defects: '/pms/pms-defects',
  pms_tools: '/pms/pms-tools',
  pms_documents: '/pms/pms-documents',
  spare_libraries: '/spares/spare-libraries',
  spare_categories: '/parameters/purchasing?section=spares-items',
  spare_items: '/parameters/purchasing?section=spares-items',
  spare_reference_templates: '/system/reference-templates?moduleId=spares',
  store_items: '/parameters/purchasing?section=supplies-items',
  store_catalogs: '/supplies/store-catalogs',
  store_categories: '/parameters/purchasing?section=supplies-categories',
  store_units: '/parameters/purchasing?section=supplies-units',
  vessels: '/parameters/general?section=vessels',
  ports: '/parameters/general?section=ports',
  countries: '/parameters/general?section=countries',
  currencies: '/parameters/general?section=currencies',
  departments: '/parameters/general?section=departments',
  management_companies: '/parameters/general?section=management-companies',
  crew_parameters: '/parameters/crew',
  suppliers: '/parameters/general?section=entities',
  crew: '/crew',
  mga: '/mga',
  wrh: '/wrh',
  e_form_submissions: '/e-forms',
  e_form_definitions: '/e-forms/builder',
  noon_reports: '/operations/noon-reports',
  users: '/admin/users',
  import_impa: '/admin/import-actions/impa-code',
  import_accounts_plan: '/admin/import-actions/accounts-plan',
  import_companies: '/admin/import-actions/companies',
  import_journals: '/admin/import-actions/journals',
  database_browser: '/admin/database-browser',
  ai_billing: '/admin/ai-billing',
};

export function resolveLandingPathForModuleKey(moduleKey: string, vesselId?: number | null): string | undefined {
  const path = LANDING_MODULE_PATHS[moduleKey as LandingModuleKey];
  if (!path) return undefined;
  if (!path.includes(':id')) return path;
  const safeVesselId = vesselId != null && Number.isFinite(Number(vesselId)) && Number(vesselId) > 0
    ? Number(vesselId)
    : null;
  if (safeVesselId == null) return undefined;
  return path.replace(':id', String(safeVesselId));
}

/**
 * Get permission module key for a path. Checks exact match then prefix (e.g. /reports/... -> reports).
 */
export function getModuleKeyForPath(path: string): string | undefined {
  const normalized = path.split('?')[0];
  if (normalized.startsWith('/e-forms/builder')) return 'e_form_definitions';
  if (normalized.startsWith('/e-forms')) return 'e_form_submissions';
  if (normalized.startsWith('/operations/noon-reports')) return 'noon_reports';
  if (normalized.startsWith('/parameters/crew/') || normalized === '/parameters/crew') {
    return 'crew_parameters';
  }
  if (normalized === '/parameters/general') return 'vessels';
  if (normalized === '/parameters/purchasing') return 'store_items';
  if (normalized === '/parameters/supplies-catalog') return 'store_items';
  if (normalized === '/parameters/spares-catalog') return 'spare_items';
  if (normalized === '/parameters/pms') return 'pms_record_statuses';
  if (normalized === '/parameters/finance') return 'acc_companies';
  if (normalized.includes('/vessel-modules/') && normalized.includes('/dashboard')) {
    return 'vessel_dashboard';
  }
  if (normalized.includes('/vessel-modules/') && normalized.includes('/pending-deliveries')) {
    return 'vessel_pending_deliveries';
  }
  if (normalized.includes('/vessel-modules/') && normalized.includes('/requisitions')) {
    return 'vessel_supply_requisitions';
  }
  if (PATH_TO_MODULE_KEY[normalized]) return PATH_TO_MODULE_KEY[normalized];
  const segment = normalized.split('/').filter(Boolean)[0];
  if (!segment) return undefined;
  const byPrefix = Object.entries(PATH_TO_MODULE_KEY).find(
    ([p]) => p.startsWith('/' + segment) || normalized.startsWith(p),
  );
  return byPrefix?.[1];
}
